import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import {
  Box,
  Button,
  Container,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { AuthContext } from "../../auth/authContext";
import md5 from "md5";
import Copyright from "../../component/Copyright";
import { BackendAPI } from "../../const/api";
import request from "../../api/request";

const LoginChangePassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const authContext = useContext(AuthContext);

  const handlePasswordChange = (psw, confirm = false) => {
    if (confirm) {
      setConfirmPassword(psw);
    } else {
      setPassword(psw);
    }
    if (confirm && psw !== password) {
      setError("两次密码输入不一致");
      return;
    }
    // 执行密码格式校验
    if (!validatePassword(psw)) {
      setError("密码必须包含至少6位字母和数字的组合");
    } else {
      setError("");
    }
  };

  const validatePassword = (psw) => {
    return /^(?=.*[A-Za-z])(?=.*\d).{6,}$/.test(psw);
  };

  const handleChange = async (event) => {
    event.preventDefault();
    setError("");
    const encryptedPassword = md5(password);
    try {
      if (authContext && authContext.user && authContext.user.name) {
        const res = await request.put(BackendAPI.userPassword, {
          newPassword: encryptedPassword,
        });
        if (res.message) {
          setError(res.message);
        } else {
          await authContext.login(authContext.user.name, encryptedPassword);
          navigate("/login");
        }
      } else {
        setError("修改失败，请刷新页面重试");
      }
    } catch (e) {
      console.error(e);
      if (e instanceof Error) {
        setError(e.message || "修改请求出错");
      } else {
        setError("修改请求出错");
      }
    }
  };

  return (
    <Container component="main" className="loginContainer">
      <Paper elevation={3} className="loginPaper">
        <Typography component="h1" variant="h5">
          {`${authContext?.user?.name} 您好，您的账号已较长时间未修改密码，为了您的账号安全，请修改密码后登陆`}
        </Typography>
        <Box component="form" onSubmit={handleChange} className="loginForm">
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            label="密码"
            autoComplete="password"
            type="password"
            value={password}
            onChange={(e) => handlePasswordChange(e.target.value)}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            label="确认密码"
            type="password"
            value={confirmPassword}
            onChange={(e) => handlePasswordChange(e.target.value, true)}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className="loginButton"
            disabled={error !== ""}
          >
            更新密码
          </Button>
          {error && <div className="loginError">{error}</div>}
        </Box>
      </Paper>
      <Copyright />
    </Container>
  );
};

export default LoginChangePassword;
